module.exports = __webpack_public_path__ + "img/29.88d1cf60.png";